class ClientActivationRetryUsersController {
    static controller($scope) {
        'ngInject';
    };
}

export default ClientActivationRetryUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-activation-retry.users.controller.js